import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TextToVoiceService {

  constructor() { }

  speak(text: string): void {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'en-US';
      window.speechSynthesis.speak(utterance);
    } else {
      console.error('Speech Synthesis not supported in this browser.');
    }
  }

  stop(): void {
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }
  }

}